import { render } from "./HeaderLogo.vue?vue&type=template&id=8f5a4f64&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"

import "./HeaderLogo.vue?vue&type=style&index=0&id=8f5a4f64&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5a4f64"]])

export default __exports__